import { NavBar } from '../../layout/navbar/navbar.component'
import { SideBar } from '../../layout/sidebar/sidebar.component'
import { Outlet } from 'react-router-dom'
import { PopUpDialog } from '../../components/modals/popupDialog.component'
import vr from '../../assets/images/video.mp4'
import { OpenIdeaDialog } from '../../components/modals/openIdeaDialog.component'

import { FeedbackDialog } from '../../components/modals/feedbackDialog.component'
import { MobileMenu } from '../../components/mobileMenu/mobileMenu.component'
export const AdminHomePage = () => {
    return (
        <>
            <div className="vertical-layout vertical-menu-modern navbar-floating footer-static menu-collapsed" data-menu="vertical-menu-modern">
                <video
                    className='bg'
                    src={vr}
                    autoPlay
                    loop
                    playsInline
                    muted
                />
                <NavBar isSearchBar={false} />
                <SideBar />
                <Outlet />
                <PopUpDialog modelType={"listModel"} />
            <OpenIdeaDialog />
            <FeedbackDialog modalType={"feedbackModal"}/>
            <MobileMenu />
            </div>
        </>
    )
}